const { conf, getHostConfig, t } = require('./configService');

module.exports = { conf, getHostConfig, t };
